import { TableCellType } from "@/constants/table/table"
import { Credential } from "@/types/credentials"
import { ColumnDef } from "@tanstack/react-table"

/**
 * Credential table column definitions.
 *
 * Direction A (CEO-chosen, TDD §"List — Status column"):
 * - icon (44px)
 * - Nickname
 * - Status (300px) — dedicated column between Nickname and Actions (new)
 * - Actions (230px, right-aligned)
 *
 * The "expiry" column is retained for the §23 ExpiryChip rendered inline below
 * each row — it is a colspan trick, not a real table column.
 *
 * Brand guide §38. Slice 3.2 — credential-status Epic 3.
 */
export const columns: ColumnDef<Credential>[] = [
  {
    accessorKey: "icon",
    header: "",
    meta: { type: TableCellType.ICONS, className: "w-6 p-0 px-4" },
  },
  {
    accessorKey: "nickname",
    header: "Nickname",
    meta: { type: TableCellType.LINK_BUTTON },
  },
  {
    id: "expiry",
    header: "",
    accessorFn: () => null,
    meta: { type: TableCellType.STATUS },
  },
  {
    id: "connectionStatus",
    header: "Status",
    accessorFn: () => null,
    meta: { type: TableCellType.STATUS, className: "w-[300px]" },
  },
  {
    accessorKey: "actions",
    header: "Actions",
    meta: { type: TableCellType.ACTIONS },
  }
]
